import script from "./MatrizPosicionamiento.vue?vue&type=script&setup=true&lang=js"
export * from "./MatrizPosicionamiento.vue?vue&type=script&setup=true&lang=js"

import "./MatrizPosicionamiento.vue?vue&type=style&index=0&id=29233cf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29233cf2"]])

export default __exports__